import { render } from "./SocialLinks.vue?vue&type=template&id=1687d1ca&scoped=true"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=1687d1ca&scoped=true&lang=css"

import exportComponent from "../../../biotron-complaint-20260813/WebMidiVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1687d1ca"]])

export default __exports__